import React from 'react';
import { RenderElementProps } from 'slate-react';
import { IframeWrapper } from './Iframe.styled';

export type IframeProps = {
  attributes?: RenderElementProps['attributes'];
  title: string;
  src: string;
  isSelected?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children?: React.ReactNode;
  iframeTestId?: string;
  containerTestId?: string;
  allowFullScreen?: boolean;
};

export const Iframe = ({
  attributes,
  title,
  src,
  isSelected,
  onMouseEnter,
  onMouseLeave,
  children,
  iframeTestId,
  containerTestId,
  allowFullScreen,
}: IframeProps) => (
  <IframeWrapper
    {...attributes}
    data-testid={containerTestId}
    isSelected={isSelected}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <iframe
      data-testid={iframeTestId}
      title={title}
      src={src}
      contentEditable={false}
      allowFullScreen={allowFullScreen}
      frameBorder="0"
    />
    {children}
  </IframeWrapper>
);
